import type { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { buildHomePageComponentsMap } from "../../blocks/componentMaps";

import styles from "./index.module.scss";

const richTextUnwrap = (value: string): string =>
    value.replace(/class="rich-text"/g, "");

const HomePageStreamField = (
    props: Immutable<{
        page: templates.HomePageTemplate["page"];
        chill_url: string;
        classic_url: string;
    }>,
): React.JSX.Element | null => {
    if (!props.page.body) {
        return null;
    }
    const components = buildHomePageComponentsMap({
        pageSlug: props.page.slug,
        homeOprahChillUrl: props.chill_url,
        homeOprahClassicUrl: props.classic_url,
    });
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.page.body.value}
            components={components}
        />
    );
};

export const HomePageBody = (
    props: Immutable<Omit<templates.HomePageTemplate, "page_chrome">>,
): React.JSX.Element => {
    return (
        <>
            <section
                className={concatClassNames([
                    styles.homeOct16Hero,
                    "hero",
                    "home-oct16-hero",
                ])}
            >
                <picture>
                    {props.mobile_hero_url && (
                        <source
                            srcSet={props.mobile_hero_url}
                            media="(max-width: 500px)"
                        />
                    )}
                    {props.hero_url && (
                        <img
                            srcSet={props.hero_url}
                            alt={props.hero_alt}
                            fetchPriority="high"
                        />
                    )}
                </picture>
                <div
                    className={concatClassNames([
                        styles.homeOct16HeroCopy,
                        "home-oct16-hero__copy",
                    ])}
                >
                    <div
                        className={styles.homeOct16HeroDescription}
                        dangerouslySetInnerHTML={{
                            __html: props.page.hero_description.html,
                        }}
                    />
                    {props.page.mobile_hero_description.html && (
                        <div
                            className={concatClassNames([
                                styles.homeOct16HeroDescription,
                                styles.homeOct16HeroDescriptionMobile,
                            ])}
                            dangerouslySetInnerHTML={{
                                __html: props.page.mobile_hero_description.html,
                            }}
                        />
                    )}
                    <div
                        className={styles.homeOct16HeroPricing}
                        dangerouslySetInnerHTML={{
                            __html: richTextUnwrap(
                                props.page.hero_pricing.html,
                            ),
                        }}
                    />
                    {props.learn_more_url && (
                        <p>
                            <a href={props.learn_more_url}>
                                {props.learn_more_title}
                            </a>
                        </p>
                    )}
                </div>
            </section>

            <HomePageStreamField
                page={props.page}
                chill_url={props.chill_url}
                classic_url={props.classic_url}
            />
        </>
    );
};
